<template>
  <div v-show="showDetails">
    <!-- <div id='overlay' @click='$emit("close-details")'></div> -->
    <div id="details">
      <header id="header" class="row">
        <div :class="`col-xs-12 monit-item bg-${statusColor}`">
          <h5 class="mb-0 pt-1">{{ Object.keys(item).length && item.NAME }}</h5>
          <div class="update">
            <clock-icon title="" /> {{ updated }}
          </div>
        </div>
        <div :class="`col-xs-6 monit-tabs ${active == 'info' ? 'active' : ''}`" @click="selectDetails(0)">
          Informações
        </div>
        <div :class="`col-xs-6 monit-tabs ${active == 'charts' ? 'active' : ''}`" @click="selectDetails(1)">
          Gráficos
        </div>
      </header>
      <div class="column details-area  pl-2 pr-2">
        <div class="col-xs-12 content" v-if="active == 'info'">
          <center class="mt-2">
            <div class="info-status">
              <div class="flow-status">
                <div :class="`ball bg-${statusColor}`"></div>
                <div v-if="item.OPEN" :class="`statusActuator`">
                  Aberta
                  <arrow-up-icon v-if="item.FLOW > item.MAX_FLOW" title="" />
                  <arrow-down-icon v-else-if="item.FLOW < item.MIN_FLOW" title="" />
                </div>
                <div :class="`statusActuator`" v-else>Fechada</div>
              </div>
              <div :class="`statusActuator`">
                / {{ item.MANUAL ? "Manual" : "Automático" }}
              </div>
            </div>
          </center>

          <div v-if="item.GENERIC && item.FLOW >= 0" class="info-title">
            Medições
          </div>
          <div class="col-xs-12 info-details mt-2">
            <div class="">
              <div v-if="item.FLOW >= 0">
                <strong>Vazão:</strong> {{ item.FLOW }} {{ item.UNIT_FLOW
                }}<br />
              </div>
              <div v-if="item.GENERIC" class="generic-details">
                <div v-for="(g, i) in item.GENERIC" :key="i" class="m-0">
                  <span>
                    <strong>{{ g.NAME }}</strong> {{ g.VALUE }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="info-title mt-2">Detalhes</div>
          <div class="col-xs-12 info-details">
            <strong>ID:</strong> {{ item.ID }}<br />
            <strong>Modelo:</strong> {{ item.MODEL }}<br />
            <span><strong>Dispositivo:</strong> {{ item.DIR }}</span><br />
            <span v-if="item.PUMP"><strong>Bomba:</strong> {{ item.PUMP }}<br /></span>
            <span v-if="item.HYDRO"><strong>Hidrômetro:</strong> {{ item.HYDRO }}<br /></span>
            <span v-if="item.NOTE"><strong>Observação:</strong> {{ item.NOTE }}<br /></span>
            <span v-if="item.MIN_FLOW > 0"><strong>Vazão mínima:</strong> {{ item.MIN_FLOW }}
              {{ item.UNIT_FLOW }}<br /></span>
            <span v-if="item.MAX_FLOW > 0"><strong>Vazão máxima:</strong> {{ item.MAX_FLOW }}
              {{ item.UNIT_FLOW }}<br /></span>
          </div>
          <!-- <div class="info-title">Dispositivo</div> -->
          <!-- <div class="col-xs-12 info-details">
            <span><strong>Dispositivo:</strong> {{ item.DIR }}</span
            ><br />
            <div v-for="(dir, i) in item.DIR_DETAILS" :key="i">
              <strong>Bateria: </strong>{{ dir.BAT }}V <br />
              <strong>Sinal: </strong
              >{{
                dir.RF && dir.RF.ack && dir.RF.ack.length == 2
                  ? calculatePercentage(dir.RF.ack[0], dir.RF.ack[1]) + "%"
                  : "Sem sinal"
              }}
            </div>
          </div> -->

          <!-- :id="`collapse-${item.ID}`" -->
          <!-- :class="visible ? null : 'collapsed'"
            :aria-expanded="visible ? 'true' : 'false'" -->
          <b-button class="col-12 mt-2" variant="outline-secondary" rounded pill @click="visible = !visible" size="sm"
            :aria-expanded="visible ? 'true' : 'false'" :class="visible ? null : 'collapsed'">
            {{
            visible
            ? "Ocultar comandos do atuador"
            : "Exibir comandos do atuador"
            }}
          </b-button>
          <b-collapse id="collapse-4" class="mb-1" v-model="visible">
            <p class="warning-command mt-3">
              <alert-icon /> Utilize os comandos do atuador com cuidado.
              <!-- <alert-icon/> Pressione o botão para exibir os comandos do atuador (ou sensor, se for o caso). Utilize os comandos com cuidado. -->
            </p>
            <!-- <div class="info-title">Comandos avançados</div> -->
            <div class="info-title mt-2">
              {{ item.MANUAL ? "Manual" : "Automático" }}
            </div>
            <div class="row middle-xs mb-1 mt-1">
              <div class="col-xs-12">
                <b-button :variant="item.MANUAL ? 'orange' : '3v3'" block @click="manualState()" size="sm">
                  ALTERAR
                </b-button>
              </div>
            </div>
            <!-- <p /> -->
            <div class="row around-xs" v-if="item.MANUAL">
              <div class="col-xs-6">
                <b-button squared variant="3v3" block @click="changeStatus(1)" size="sm">
                  LIGAR
                </b-button>
              </div>
              <div class="col-xs-6">
                <b-button squared variant="black" block @click="changeStatus(0)" size="sm">
                  DESLIGAR
                </b-button>
              </div>
            </div>

            <div v-else class="obs-info">
              <em>Para operar o equipamento, coloque-o em modo MANUAL.</em>
            </div>
            <div class="mb-4 mt-4">
              <div v-for="button in item.BUTTONS" :key="button.name" class="buttons">
                <b-button variant="3v3" block @click="buttons(button.COMMAND)" size="sm">
                  {{ button.NAME }}
                </b-button>
              </div>
            </div>
            <!-- COMMANDS -->
            <div class="middle-xs mb-1 mt-1 container-command">
              <b-input-group class="command-button row mr-0 ml-0 p-0" v-for="(btn, i) in listButtons" :key="i">
                <!-- <div class="row"> -->
                <label :for="`field-${i}`" class="label col-12 p-0 mb-1">{{ btn.LABEL }}:</label>

                <b-form-input :id="`field-${i}`" type="text" placeholder="Digite o comando" class="col-10" ref="input"
                  size="sm" />
                <b-input-group-append>
                  <!-- squared -->
                  <b-button :variant="item.MANUAL ? 'orange' : '3v3'" block class="cmd-button"
                    @click="sendButton(i, btn)" rounded size="sm">
                    <!-- {{ btn.BUTTON }} -->
                    ENVIAR
                  </b-button>
                </b-input-group-append>
                <div v-if="btn.STATUS !== ''" class="obs-info col-12 text-left p-1 mt-1 status">
                  {{ btn.STATUS }}
                </div>

                <!-- </div> -->
              </b-input-group>
            </div>
          </b-collapse>
        </div>
        <div class="col-xs-12 content chart" v-else>
          <actuatorCharts eqp="ACTUATOR" :name="item.NAME" :area="item.AREA" :is-mobile="isMobile" :columns="
            item.AREA
              ? ['FLOW', 'VOL', 'DEPTH', 'OPEN']
              : ['FLOW', 'VOL', 'OPEN']
          " :currently-values="{
              FLOW: item.FLOW,
              VOL:
                item.GENERIC.length &&
                item.GENERIC.filter((e) => e.NAME == 'VOL').length
                  ? item.GENERIC.filter((e) => e.NAME == 'VOL')[0].VALUE
                  : 0,
              OPEN: item.OPEN,
            }" :col-names="
              item.AREA
                ? [
                    {
                      value: 'FLOW',
                      text: 'VAZÃO',
                    },
                    {
                      value: 'VOL',
                      text: 'VOLUME',
                    },
                    {
                      value: 'DEPTH',
                      text: 'LÂMINA',
                    },
                    {
                      value: 'OPEN',
                      text: 'ATUAÇÃO',
                    },
                  ]
                : [
                    {
                      value: 'FLOW',
                      text: 'VAZÃO',
                    },
                    {
                      value: 'VOL',
                      text: 'VOLUME',
                    },
                    {
                      value: 'OPEN',
                      text: 'ATUAÇÃO',
                    },
                  ]
            " />
        </div>
      </div>
      <footer id="footer">
        <button size="sm" block @click="$emit('close-details')" :class="`close-button bg-${statusColor}`">
          Fechar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { cmd } from "@/api";
import actuatorCharts from "@/pages/monitoringPages/Actuators/components/ActuatorCharts";
export default {
  name: "actuator-details",
  components: {
    actuatorCharts,
  },
  props: {
    item: Object,
    statusColor: String,
    isMobile: Boolean,
    updated: String,
    ending: String,
    showDetails: Boolean,
  },

  data() {
    return {
      active: "info",
      visible: false,
    };
  },
  watch: {
    showDetails(newValue, oldValue) {
      if (!newValue && oldValue) this.active = "info";
    },
    item(newValue, oldValue) {
      if (Object.keys(newValue).length && newValue.ID != oldValue.ID)
        this.active = "info";
    },
    isMobile() {
      this.showDetailsActuators(this.active);
    },
    active(newValue, oldValue) {
      this.showDetailsActuators(newValue);
    },
  },
  computed: {
    listButtons() {
      return this.item.INPUTS;
    },
  },
  methods: {
    showComands(id) {
      console.log(this.ending);
    },
    sendButton(i, btn) {
      let newCMD = btn.CMD.concat(" ", this.$refs.input[i].$el.value);
      this.buttons(newCMD);
    },
    showDetailsActuators(active) {
      let details = document.getElementById("details");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      if (active == "info") {
        let width = this.isMobile ? "100%" : "361px";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      } else if (active == "charts") {
        let width = this.isMobile ? "100%" : "calc(100% - 51px)";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      }
    },
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    selectDetails(idx) {
      let tabs = ["info", "charts"];
      this.active = tabs[idx];
    },
    getResFw(file) {
      setTimeout((_) => {
        cmd
          .resfw(file)
          .then((ret) => {
            if (ret.status) {
              wait.hide();
              if (ret.value == "0") console.log("Sucesso na solicitação");
              else console.log("Falha na soliticação");
            } else {
              if (this.errFwRes < 5) {
                this.errFwRes++;
                console.log(
                  `Erro ao tentar ler arquivo. Tentativa: ${this.errFwRes}`
                );
                this.getResFw(file);
              } else {
                wait.hide();
                console.log("Falha na solicitação");
              }
            }
          })
          .catch((err) => {
            console.log(err);
            wait.hide();
          });
      }, 2000);
    },
    manualState() {
      let SET = !this.item.MANUAL;
      let CMD = SET ? "SET_MANUAL" : "SET_AUTO";
      let data = { SET, CMD };
      this.changeProp(data, "actuatorsetmode");
    },
    changeStatus(SET) {
      let CMD = SET ? "SET_OPEN" : "SET_CLOSE";
      let data = { SET, CMD };
      this.changeProp(data, "actuatorsetstate");
    },
    buttons(command) {
      let SET = true;
      let CMD = command;
      let data = { SET, CMD };
      this.changeProp(data, "reqofw");
    },
    changeProp(data, apiFunction) {
      data.ITEM = this.item.ID;
      wait.show();
      cmd[apiFunction](data)
        .then((ret) => {
          if (ret.status) {
            let FILE = ret.value;
            this.getResFw({ FILE });
          } else {
            console.log(ret.log);
            wait.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
  },
};
</script>

<style scoped>
.buttons {
  margin-top: 5px;
}

.container-command div+div {
  margin-top: 6px;
}

.warning-command {
  font-size: 0.8em;
  color: #616161;
  margin-bottom: 0px;
  padding: 8px;
  background-color: #f5f7a593;
  border-radius: 4px;
}

.warning-command .material-design-icon {
  font-size: 0.9em !important;
}

.container-command .cmd-button {
  margin-right: 0px;
}

.label {
  padding: 0;
  font-size: 0.8em;
  /* margin: 0; */
}

.status {
  background: #d0ddcca6;
  border-radius: 4px;
}

.statusActuator {
  font-size: 1.4em;
  color: #7d7d7d;
}

.info-status {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ball {
  width: 0.7em;
  height: 0.7em;
  border-radius: 100%;
  margin-right: 7px;
}

.flow-status {
  display: flex;
  align-items: center;
  margin-right: 4px;
}

.obs-info {
  text-align: center;
  font-size: 0.68em;
}

.close-button {
  border: none;
  width: 100%;
  border-radius: 4px;
  color: #ffff;
  outline: none;
}

.close-button:hover {
  filter: contrast(80%);
}
</style>
